<template>
  <el-dialog :visible.sync="dialogVisible" title="充值" width="600px" center>
    <el-form ref="rechangeModal" :model="form" label-suffix=":" class="payFormModal" label-width="90px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="收款公司"><span class="disuse-font inline" style="line-height:normal;">{{ bankInfo.company_name }}</span></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行"><span class="disuse-font inline" style="line-height:normal;padding-top: 7px;">{{ bankInfo.bank_name }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="收款账号"><span class="disuse-font bold inline" style="line-height:normal;">{{ bankInfo.bank_card }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="充值方式">线下对公转账</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务费率">{{ source.rate }}%</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="充值金额"
            prop="recharge_price"
            :rules="[{
              required: true, message: '充值金额不能为空', trigger: 'blur'
            }, {validator: validatorFn, trigger: 'blur'}]"
          >
            <el-input v-model="form.recharge_price" class="w150" @input="changeFn" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务费">￥{{ serviceCost || '0.00' }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="上传凭证"
            prop="pic"
            :rules="{
              required: true, message: '请上传凭证', trigger: 'blur'
            }"
          >
            <el-upload
              action="#"
              :auto-upload="true"
              :before-upload="beforeUploadFile"
              :http-request="doUploadFile"
              :multiple="false"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <span class="ml5 fs12">可以上传doc/docx/pdf/jpg/png/xls/xlsx文件,且不超过20M</span>
              <!-- <el-tooltip class="item" effect="dark" content="可以上传doc/docx/pdf/jpg/png/xls/xlsx文件,且不超过20M" placement="top-start">
                <i class="ml5 el-icon-warning" />
              </el-tooltip> -->
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider />
      <div class="tit mb10">商户号充值可分配金额：￥{{ clientReal || '0.00' }}</div>
      <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id" class="mch-item">
        <el-form-item :label="`商户号${index + 1}`">
          {{ mch_list.mch_id }}
        </el-form-item>
        <el-form-item
          label="充值金额"
          :prop="'mch_list.' + index + '.price'"
          :rules="{
            required: true, message: '充值金额不能为空', trigger: 'blur'
          }"
        >
          <el-input v-model="mch_list.price" class="w200" @input="(val) => changeValue(val, index)" />
        </el-form-item>
      </div>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFn('rechangeModal')">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/api/common'
import { getBankInfo } from '@/api/refund'
export default {
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      bankInfo: {},
      form: {
        recharge_price: '', // 充值金额
        pic: '', // 上传凭证
        mch_list: [] // 分配商户号金额
      }
    }
  },
  computed: {
    // 商户号充值可分配金额
    clientReal() {
      // 总的充值金额 - 服务费
      return this.toDecimal(this.div(this.form.recharge_price, this.add(1, (this.div(this.source.rate, 100)))))
    },
    // 服务费
    serviceCost() {
      // 总的充值金额 * 服务费率
      return this.toDecimal(this.sub(this.form.recharge_price, this.clientReal) || 0.00)
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      if (!value) {
        // 重置
        this.fileList = []
        this.form.recharge_price = '' // 充值金额
        this.form.pic = '' // 上传凭证
        this.form.mch_list = [] // 分配商户号金额
        this.$emit('update:visible', false)
      }
    },
    source: {
      handler(val) {
        if (val && val.mch_list && val.mch_list.length) {
          val.mch_list.forEach(item => {
            this.form.mch_list.push({
              mch_id: item,
              price: ''
            })
          })
        }
      },
      deep: true
    }
  },
  mounted() {
    getBankInfo().then(res => {
      this.bankInfo = res.data
    })
  },
  methods: {
    async submitFn(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (+this.clientReal !== sum) {
        this.$message({ type: 'error', message: '商户号充值金额与商户号充值可分配金额不相等!' })
        return
      }
      this.$emit('submitFn', this.form)
    },
    changeValue(val, i) {
      this.form.mch_list[i].price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    changeFn(val) {
      this.form.recharge_price = val.replace(/[^\d\.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    beforeUploadFile(file) {
      const type = /^(.doc|.docx|.pdf|.jpg|.png|.xls|.xlsx)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('不支持该文件类型,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    doUploadFile(file) {
      const params = new FormData()
      params.append('file', file.file)
      uploadFile(params).then(res => {
        if (res.code === 200) {
          this.form.pic = res.data
        }
      })
    },
    handleExceed() {
      this.$message('最多可上传1个文件')
    },
    handleRemove() {
      this.form.pic = ''
    },
    validatorFn(rule, value, callback) {
      if (+value <= 0) {
        callback(new Error(`金额必须大于0`))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-form-item{
    margin-bottom: 18px;
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
  .el-upload__tip{
    line-height: 20px;
  }
}
.payFormModal .tit{
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.mch-item{
  background: #FAFAFA;
  padding:  10px 0;
  margin-bottom: 10px;
  &:last-child{
    margin-bottom: 0;
  }
}

</style>
